module.exports = __webpack_public_path__ + "img/Helzberg_logo.f8ada531.png";